import { Box, Typography } from "@mui/material";

const ASSET_LOGO = `${process.env.PUBLIC_URL || ""}/brand/logo.png`;
const ASSET_ICON = `${process.env.PUBLIC_URL || ""}/brand/icon.png`;

/**
 * Logo da marca Stock Sistema.
 *
 * Variantes:
 *   - "full"    -> logo completo (ícone + wordmark) em uma única imagem.
 *   - "compact" -> apenas o ícone (cubos isométricos com seta).
 *   - "stacked" -> ícone + texto "Stock Sistema" (lado a lado, com tipografia local).
 */
export default function Logo({ variant = "stacked", size = 36, color = "primary.main", sx = {} }) {
  if (variant === "full") {
    return (
      <Box
        component="img"
        src={ASSET_LOGO}
        alt="Stock Sistema"
        data-testid="brand-logo-full"
        sx={{ height: size, width: "auto", display: "block", ...sx }}
      />
    );
  }

  if (variant === "compact") {
    return (
      <Box
        component="img"
        src={ASSET_ICON}
        alt="Stock Sistema"
        data-testid="brand-logo-icon"
        sx={{ height: size, width: size, display: "block", ...sx }}
      />
    );
  }

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", gap: 1.25, ...sx }}
      data-testid="brand-logo-stacked"
    >
      <Box
        component="img"
        src={ASSET_ICON}
        alt="Stock Sistema"
        sx={{ height: size, width: size, display: "block" }}
      />
      <Typography
        variant="h6"
        fontWeight={700}
        sx={{
          color,
          letterSpacing: 0,
          lineHeight: 1,
          fontSize: size >= 40 ? "1.35rem" : "1.1rem",
        }}
      >
        Stock Sistema
      </Typography>
    </Box>
  );
}
